import React from 'react';

const PantallaBloqueo = ({ diasGracia = 0 }) => {
    const esPeriodoGracia = diasGracia > 0;

    return (
        <div style={{
            position: 'fixed', top: 0, left: 0, width: '100vw', height: '100vh',
            backgroundColor: '#0f0f1a', color: 'white', zIndex: 99999,
            display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center',
            textAlign: 'center', padding: '20px'
        }}>
            {/* Icono */}
            <div style={{
                width: '120px', height: '120px', borderRadius: '50%',
                backgroundColor: esPeriodoGracia ? 'rgba(245,158,11,0.15)' : 'rgba(231,76,60,0.15)',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                marginBottom: '30px'
            }}>
                <i className="bi bi-shield-lock-fill" style={{
                    fontSize: '60px',
                    color: esPeriodoGracia ? '#f59e0b' : '#e74c3c'
                }} />
            </div>

            <h1 style={{ fontWeight: 800, fontSize: '2.2rem', marginBottom: '8px', letterSpacing: '-0.5px' }}>
                {esPeriodoGracia ? 'PAGO PENDIENTE' : 'BLOQUEADO POR MOROSIDAD'}
            </h1>
            <p style={{ fontSize: '14px', opacity: 0.5, marginBottom: '30px' }}>
                {esPeriodoGracia
                    ? `Tienes ${diasGracia} día${diasGracia !== 1 ? 's' : ''} para regularizar antes del bloqueo`
                    : 'El acceso ha sido suspendido por falta de pago'}
            </p>

            <hr style={{ width: '200px', borderColor: 'rgba(255,255,255,0.1)', marginBottom: '28px' }} />

            <div style={{
                maxWidth: '500px',
                backgroundColor: esPeriodoGracia ? 'rgba(245,158,11,0.08)' : 'rgba(231,76,60,0.08)',
                border: `1px solid ${esPeriodoGracia ? 'rgba(245,158,11,0.25)' : 'rgba(231,76,60,0.25)'}`,
                borderRadius: '16px', padding: '24px 30px', marginBottom: '20px'
            }}>
                <p style={{ fontSize: '16px', lineHeight: '1.7', margin: 0, opacity: 0.9 }}>
                    Para reactivar el servicio, comunícate con tu proveedor
                    y regulariza el pago de tu suscripción.
                </p>
            </div>

            <div style={{
                backgroundColor: 'rgba(255,255,255,0.04)', borderRadius: '12px',
                padding: '14px 24px', marginBottom: '24px'
            }}>
                <p style={{ margin: 0, fontSize: '13px', opacity: 0.6 }}>
                    <i className="bi bi-envelope-fill me-2" />
                    soporte@komity.cl
                </p>
            </div>

            <a
                href="https://wa.me/56920039433?text=Hola%2C+tengo+problemas+con+mi+servicio+Komity+bloqueado"
                target="_blank"
                rel="noreferrer"
                style={{
                    display: 'inline-flex', alignItems: 'center', gap: '8px',
                    background: '#25D366', color: '#fff', borderRadius: '50px',
                    padding: '12px 24px', textDecoration: 'none', fontWeight: 700,
                    fontSize: '15px', marginBottom: '28px',
                    boxShadow: '0 4px 15px rgba(37,211,102,0.35)'
                }}
            >
                <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor"><path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z"/></svg>
                Regularizar por WhatsApp
            </a>

            <div style={{ fontSize: '11px', opacity: 0.25 }}>
                <i className="bi bi-shield-lock me-1" />
                Komity — Sistema de gestión gastronómica
            </div>
        </div>
    );
};

export default PantallaBloqueo;
